<template>
    <div class="flex-grow-1-scroll h-100 no-gutters provider-content" ref="container">

        <div class='position-relative d-flex flex-column h-100'>
            <loading ref="loading"></loading>

            <div class='flex-grow-1-scroll h-100'>
                <div class="errors">
					<template v-for="(error, key) in errors">
						<p :key='"" + key + "-" + mkey' class="alert alert-warning" v-for="(message, mkey) in error">{{message}}</p>
					</template>
				</div>
                <div v-if='provider.demo_mode'>
                    <div class="pl-3 pr-3 mt-3">

                        <div class="d-flex flex-column pl-0">
                            <h1 class="h2">{{ $t('translations.digital_triage_results')}}</h1>
                            <!-- <template v-if='is_network_admin()'>
                                <label class="p-0 col-4">{{ $t('translations.provider')}}</label>
                                <select v-model='provider_id'  class="form-control col-4 mb-2">
                                    <option v-for="provider in sortByValue($root.lookup.providers)" :value="provider.id" :key="provider.id">{{provider.name}}</option>
                                </select>
                            </template> -->
                        </div>
                        <div class="">
                            <table class="table table-bordered table-compact bg-white text-center">
                                <thead>
                                    <tr>
                                        <th colspan="2" rowspan="2"></th>
                                        <th rowspan="2">{{ $t('translations.digital_triage')}}</th>
                                        <th colspan="3" class="text-center">{{ autobrand('translations.request_solved_by_mode') | capitalise}}</th>
                                        <th rowspan="1" colspan='3'> </th>
                                        <th rowspan="2">{{ $t('translations.other_clinician')}}</th>
                                        <th rowspan="2">{{ $t('translations.admin')}}</th>
                                    </tr>
                                    <tr>
                                        <th>{{ $t('translations.message')}}</th>
                                        <th>{{ $t('translations.telephone')}}</th>
                                        <th>{{ $t('translations.face_to_face')}}</th>
                                        <th colspan='3'>{{ $t('translations.GP')}}</th>
                                    </tr>

                                </thead>
                                <tbody>
                                    <tr>
                                        <th colspan="2" class="text-right">{{ $t('translations.average_consult_time_min')}}</th>
                                        <td class="text-right table-info table-border-separate-right"><input class='text-right' type='number' step='0.1' style='background-color: inherit; border:none; width: 5em' v-model='times["time_taken_per_request"]' v-on:change.prevent='updateTimeTaken()'></td>
                                        <td class="text-right table-info"><input class='text-right' type='number' step='0.1' style='background-color: inherit; border:none; width: 5em' v-model='times["online"]'></td>
                                        <!-- <td class="table-info" v-text='times["phone"]'>5.4</td> -->
                                        <td class="text-right table-info"><input class='text-right' type='number' step='0.1' style='background-color: inherit; border:none; width: 5em' v-model='times["phone"]'></td>
                                        <!-- <td class="table-info" v-text='times["face_to_face"]'>11.3</td> -->
                                        <td class="text-right table-info table-border-separate-right"><input class='text-right' type='number' step='0.1' style='background-color: inherit; border:none; width: 5em' v-model='times["face_to_face"]'></td>
                                        <th colspan='1'>Sum</th>
                                        <th colspan='2'> </th>

                                        <!-- <td class="table-info" v-text='times["other_clinician"]'>15</td> -->
                                        <td class="text-right table-info"><input class='text-right' type='number' step='0.1' style='background-color: inherit; border:none; width: 5em' v-model='times["other_clinician"]'></td>
                                        <!-- <td class="table-info" v-text='times["admin"]'>3</td> -->
                                        <td class="text-right table-info"><input class='text-right' type='number' step='0.1' style='background-color: inherit; border:none; width: 5em' v-model='times["admin"]'></td>
                                    </tr>

                                    <!-- <tr>
                                        <td colspan="3"></td>
                                        <td> </td>
                                        <td> </td>
                                        <td> </td>
                                        <td> </td>
                                        <th>GP</th>
                                        <th>Other clinician</th>
                                        <th>Admin</th>
                                    </tr> -->

                                    <tr>
                                        <!-- <th></th> -->
                                        <th colspan="2" class="text-right">{{ autobrand('translations.total_requests')}}</th>
                                        <td class="text-right table-dashboard-highlight table-border-separate-right" v-text='stats.closed'></td>
                                        <td class="text-right table-dashboard-highlight" v-text='getTotalAnalytics("online")'></td>
                                        <td class="text-right table-dashboard-highlight" v-text='getTotalAnalytics("phone")'></td>
                                        <td class="text-right table-dashboard-highlight table-border-separate-right" v-text='getTotalAnalytics("face_to_face")'></td>
                                        <!-- <td class="table-info" v-text='getTotalGP()'></td> -->
                                        <th class="text-left table-dashboard-highlight" v-text='getTotalGP()'></th>
                                        <th>{{ autobrand('translations.min_request')}}</th>
                                        <th>{{ autobrand('translations.min_request')}}</th>
                                        <td class="text-right table-dashboard-highlight" v-text='getTotalAnalytics("other_clinician")'></td>
                                        <td class="text-right table-dashboard-highlight" v-text='getTotalAnalytics("admin")'></td>

                                    </tr>

                                    <tr>
                                        <th colspan="2" class="text-right">{{ $t('translations.total_minutes')}}</th>
                                        <td class="text-right table-dashboard-highlight table-border-separate-right" v-text='getTotalTimeTaken()'></td>
                                        <td class="text-right table-dashboard-highlight" v-text='getTotalAnalyticsMinutes("online")'></td>
                                        <td class="text-right table-dashboard-highlight" v-text='getTotalAnalyticsMinutes("phone")'></td>
                                        <td class="text-right table-dashboard-highlight table-border-separate-right" v-text='getTotalAnalyticsMinutes("face_to_face")'></td>
                                        <td class="text-right table-dashboard-highlight font-weight-bold" v-text='getTotalGPMinutes()'></td>
                                        <td class="text-right table-dashboard-highlight font-weight-bold" v-text='getAverageMinutesPerRequest()'></td>
                                        <td class="text-right table-dashboard-highlight font-weight-bold" v-text='getTimePercentageSaved()'></td>
                                        <td class="text-right table-dashboard-highlight" v-text='getTotalAnalyticsMinutes("other_clinician")'></td>
                                        <td class="text-right table-dashboard-highlight" v-text='getTotalAnalyticsMinutes("admin")'></td>
                                    </tr>

                                    <!-- <tr>
                                        <td colspan="5"></td>
                                        <th colspan="2">Minutes/request</th>
                                        <td v-text='getAverageMinutesPerRequest()'></td>
                                        <td colspan="2"></td>
                                    </tr>

                                    <tr>
                                        <td colspan="5"></td>
                                        <th colspan="2">All face to face model</th>
                                        <td v-text='times["face_to_face"]'></td>
                                        <td colspan="2"></td>
                                    </tr>

                                    <tr>
                                        <td colspan="5"></td>
                                        <th colspan="2">Average GP time saving</th>
                                        <td class='font-weight-bold' v-text='getTimeSaved()'></td>
                                        <td class='font-weight-bold' v-text='getTimePercentageSaved()'></td>
                                        <td></td>
                                    </tr> -->
                                    <tr>
                                        <td class='table-separator' colspan='11'></td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <!-- {{ $t('translations.clinician')}} -->
                                        </th>
                                        <th>{{ $t('translations.assigned')}}</th>
                                        <th>{{ $t('translations.completed')}}</th>
                                        <th colspan='8'></th>
                                    </tr>

                                    <template v-for='(user, index) in filtered_users'>
                                        <tr :key='index'>
                                            <th class='text-left' scope="row">{{formatName(user)}}</th>
                                            <td class='text-right table-dashboard-lowlight' scope="row" v-text='(stats.user_assignment && typeof stats.user_assignment[user.id] !== "undefined" ? getTotalStat(stats.user_assignment[user.id]) : 0)'></td>
                                            <td class='text-right table-dashboard-lowlight' scope="row" v-text='(stats.user_completed && typeof stats.user_completed[user.id] !== "undefined" ? getTotalStat(stats.user_completed[user.id]) : 0)'></td>

                                            <!-- <td class="table-dashboard-highlight"><input type='number' step='0.1' style='background-color: inherit; border:none; width: 5em' v-model='stats.time_taken[user.id]'></td> -->

                                            <td class="text-right table-dashboard-lowlight" v-text='(stats.user_analytics && typeof stats.user_analytics[user.id] !== "undefined" && stats.user_analytics[user.id]["online"] ? stats.user_analytics[user.id]["online"] : 0)'>nnn</td>
                                            <td class="text-right table-dashboard-lowlight" v-text='(stats.user_analytics && typeof stats.user_analytics[user.id] !== "undefined" && stats.user_analytics[user.id]["phone"] ? stats.user_analytics[user.id]["phone"] : 0)'>nnn</td>
                                            <td class="text-right table-dashboard-lowlight" v-text='(stats.user_analytics && typeof stats.user_analytics[user.id] !== "undefined" && stats.user_analytics[user.id]["face_to_face"] ? stats.user_analytics[user.id]["face_to_face"] : 0)'>nnn</td>
                                            <td class="text-right table-dashboard-highlight" v-text='getGPMinutes(user)'></td>
                                            <td class="text-right table-dashboard-highlight" v-text='getUserAverageMinutesPerRequest(user)'></td>
                                            <td class="text-right table-dashboard-highlight" v-text='getUserTimePercentageSaved(user)'></td>
                                            <td class="text-right table-dashboard-lowlight" v-text='(stats.user_analytics && typeof stats.user_analytics[user.id] !== "undefined" && stats.user_analytics[user.id]["other_clinician"] ? stats.user_analytics[user.id]["other_clinician"] : 0)'>nnn</td>
                                            <td class="text-right table-dashboard-lowlight" v-text='(stats.user_analytics && typeof stats.user_analytics[user.id] !== "undefined" && stats.user_analytics[user.id]["admin"] ? stats.user_analytics[user.id]["admin"] : 0)'>nnn</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>


                        </div>

                    </div>
                </div>
<!-- CAPACITY DASHBOARD -->
                <div v-else class="capacity-dashboard">
                    <div class="d-flex flex-row mt-3" >
                        <div class="col-4 pr-0">
                            <h1 class="h2">{{ $t('translations.demand_and_capacity')}}</h1>
                            <!-- <template v-if='is_network_admin()'>
                                <label class="p0">{{ $t('translations.provider')}}</label>
                                <select v-model='provider_id'  class="form-control">
                                    <option v-for="provider in sortByValue($root.lookup.providers)" :value="provider.id" :key="provider.id">{{provider.name}}</option>
                                </select>
                            </template> -->
                            <label class="p0">{{ $t('translations.site')}}</label>
                            <select v-model='site_id' class="form-control">
                                <option value=''>{{ $t('translations.all_sites')}}</option>
                                <option :value='COMBINED_SITES'>{{ $t('translations.combined_sites')}}</option>

                                <option v-for='site in sortByValue(sites)' :key='site.id' :value='site.id'>{{site.name}}</option>
                            </select>
                        </div>
                        <div class="col-20 d-flex flex-row mt-0">
                            <div class="col pr-1" style="flex: 1">
                                <div class="h-100 card d-flex flex-column">
                                    <div class="pt-2 pr-2 pl-2 text-center flex-grow-1">
                                        {{ $t('translations.new')}}
                                    </div>
                                    <div class="pb-2 pr-2 pl-2 text-center flex-shrink-1">
                                        <div class="d-flex flex-row justify-content-around">
                                            <span class="flex-grow-1 text-xl pr-1">{{stats.unassigned.grand_total}}</span>
                                            <div class="text-nowrap d-flex justify-content-center flex-column">
                                                <div><span :class="'flag flag-urgent' + (stats.unassigned['10'] ? '' : '-empty')"></span>{{stats.unassigned["10"] ? stats.unassigned["10"] : 0}}</div>
                                                <div><span :class="'flag flag-emergency'  + (stats.unassigned['20'] ? '' : '-empty')"></span>{{stats.unassigned["20"] ? stats.unassigned["20"] : 0}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col pr-1" style="flex: 1">
                                <div class="h-100 card d-flex flex-column">
                                    <div class="pt-2 pr-2 pl-2 text-center flex-grow-1">
                                        {{ $t('translations.assigned')}}
                                    </div>
                                    <div class="pb-2 pr-2 pl-2 text-center flex-shrink-1">
                                        <div class="d-flex flex-row justify-content-around">
                                            <span class="flex-grow-1 text-xl">{{stats.assigned.grand_total}}</span>
                                            <div class="text-nowrap d-flex justify-content-center flex-column">
                                                <div><span :class="'flag flag-urgent' + (stats.assigned['10'] ? '' : '-empty')"></span>{{stats.assigned["10"] ? stats.assigned["10"] : 0}}</div>
                                                <div><span :class="'flag flag-emergency'  + (stats.assigned['20'] ? '' : '-empty')"></span>{{stats.assigned["20"] ? stats.assigned["20"] : 0}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="col pr-1" style="flex: 1">
                                <div class="h-100 card d-flex flex-column">
                                    <div class="pt-2 pr-2 pl-2 text-center flex-grow-1">
                                        {{ autobrand('translations.waiting_for_patient')}}
                                    </div>
                                    <div class="pb-2 pr-2 pl-2 text-center flex-shrink-1">
                                        <div class="d-flex flex-row justify-content-around">
                                            <span class="flex-grow-1 text-xl">{{stats.waiting.grand_total}}</span>
                                            <div class="text-nowrap d-flex justify-content-center flex-column">
                                                <div><span :class="'flag flag-urgent' + (stats.waiting['10'] ? '' : '-empty')"></span>{{stats.waiting["10"] ? stats.waiting["10"] : 0}}</div>
                                                <div><span :class="'flag flag-emergency'  + (stats.waiting['20'] ? '' : '-empty')"></span>{{stats.waiting["20"] ? stats.waiting["20"] : 0}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col pr-1" style="flex: 1">
                                <div class="h-100 card d-flex flex-column">
                                    <div class="pt-2 pr-2 pl-2 text-center flex-grow-1">
                                        {{ $t('translations.new_today')}}
                                    </div>
                                    <div class="pb-2 pr-2 pl-2 text-center flex-shrink-1">
                                        <span class="text-xl">{{stats.created_today}}</span>
                                    </div>
                                </div>
                            </div>


                            <div class="col" style="flex: 1">
                                <div class="h-100 card d-flex flex-column">
                                    <div class="pt-2 pr-2 pl-2 text-center flex-grow-1">
                                        {{ $t('translations.completed_today')}}
                                    </div>
                                    <div class="pb-2 pr-2 pl-2 text-center flex-shrink-1">
                                        <span class="text-xl">{{stats.closed}}</span>
                                    </div>
                                </div>
                            </div>

                            <template v-if='$root.provider.provider_provider_xref.length'>
                                <div class="col" style="flex: 0">
                                    <div class="h-100 card d-flex flex-column" style="width:1px">
                                    </div>
                                </div>

                                <div v-if='$root.provider.provider_provider_xref.length' class="col pr-1" style="flex: 1">
                                    <div class="h-100 card d-flex flex-column">
                                        <div class="pt-2 pr-2 pl-2 text-center flex-grow-1">
                                            {{ $t('translations.transferred')}}
                                        </div>
                                        <div class="pb-2 pr-2 pl-2 text-center flex-shrink-1">
                                            <span class="text-xl">{{getTotalStat(stats.transferred_provider_assignment)}}</span>
                                        </div>
                                    </div>
                                </div>

                                <div v-if='$root.provider.provider_provider_xref.length' class="col pr-1" style="flex: 1">
                                    <div class="h-100 card d-flex flex-column">
                                        <div class="pt-2 pr-2 pl-2 text-center flex-grow-1">
                                            {{ $t('translations.shared') | capitalise }}
                                        </div>
                                        <div class="pb-2 pr-2 pl-2 text-center flex-shrink-1">
                                            <span class="text-xl">{{getTotalStat(stats.shared_provider_assignment)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            </div>
                        </div>



                    </div><!-- /.d-flex -->
                    <hr>


                    <div class="pl-3 pr-3">
                        <div class="staff-rota">
                            <table class="table table-bordered table-striped table-hover">

                                <thead class="">
                                    <tr class="text-center">
                                        <th colspan="5" class="text-left">{{ capitalise($t('translations.predicted_demand')) }}</th>
                                        <th :key='index' v-for='(date, index) in calendar_dates' class="">
                                            <span v-if='show'>{{getDemand(date)}}</span>
                                            <input v-else type="number" min="0" class="text-center" v-model="demand[date.isoWeekday()].demand">
                                        </th>
                                        <th scope="col" colspan="1"><router-link to="/capacity-planning" v-if='is_superuser() || is_admin()' tag="li" class="nav"><img src="/img/icon-pencil.svg" width="20" :title="$t('translations.edit')"></router-link></th>

                                    </tr>
                                    <tr class="">
                                        <th colspan="5">{{ capitalise($t('translations.estimated_capacity')) }}</th>
                                        <td :key='index' v-for='(date, index) in calendar_dates'>{{getTotalCapacity(date)}}</td>
                                    </tr>

                                    <tr>
                                        <th scope="col" colspan="1"></th>
                                        <th scope="col" colspan="2" class="text-center currently-bg1">{{ $t('translations.now')}}</th>
                                        <th scope="col" colspan="2" class="text-center daily-bg1">{{ $t('translations.so_far_today')}}</th>
                                        <th scope="col" colspan="1"></th>
                                        <th scope="col" colspan="1"></th>
                                        <th scope="col" colspan="1"></th>
                                        <th scope="col" colspan="1"></th>
                                        <th scope="col" colspan="1"></th>
                                        <th scope="col" colspan="1"></th>
                                    </tr>
                                    <tr>
                                        <th scope="col" colspan="1" class="text-left">
                                            <!-- {{ $t('translations.clinician')}} -->
                                        </th>
                                        <th class='text-center currently-bg1' scope="col"><span>{{ $t('translations.assigned')}}</span></th>
                                        <th class='text-center currently-bg2' scope="col"><span>{{ $t('translations.waiting')}}</span></th>
                                        <th class='text-center daily-bg1' scope="col"><span>{{ $t('translations.assigned')}}</span></th>
                                        <th class='text-center daily-bg2' scope="col"><span>{{ $t('translations.completed')}}</span></th>
                                        <th :key='date.valueOf()' v-for='date in calendar_dates' scope="col" class="text-center"><span>{{ date.format("dddd") }}</span> {{date.format("Do")}}</th>
                                        <th scope="col" colspan="1"></th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <template v-for='site in filteredSites'>
                                        <tr :key='"separator-" + site.id'>
                                            <td colspan='11' class="bg-primary text-light">{{site.name}}</td>
                                        </tr>
                                        <template v-if='filtered_users_with_other_site_assign.length'>
                                            <template v-for='user in filtered_users_with_other_site_assign'>
                                                <template v-if='site.id == COMBINED_SITES || userHasSiteAvailability(user, site.id) || userHasAssignmentsFrom(user, site.id)'>
                                                    <tr :key='site.id + "-" + user.id' >
                                                        <th :title="!userHasSiteAvailability(user, site.id) && site.id != 0 && site.id != COMBINED_SITES && site.id != SHARED_TRANSFERRED_SITES ? 'Staff member has requests assigned to them from this site but have no availability defined for it' : ''"
                                                            :style='!userHasSiteAvailability(user, site.id) && site.id != 0 && site.id != COMBINED_SITES && site.id != SHARED_TRANSFERRED_SITES ? "background-color: #ffa0a0" : ""'
                                                            scope="row">
                                                            <template v-if='is_network_admin()'>{{formatName(user)}}</template>
                                                            <!-- <router-link v-else active-class='' :to='{name: "threadList", params: {assigned_to: user.id, secondary_status: []}}'>{{formatName(user)}}</router-link> -->
                                                            <router-link v-else active-class='' :to='{name: "threadList", params: {assigned_filter: user, site_id: site.id == COMBINED_SITES ? "" : site.id}}'>{{formatName(user)}}</router-link>
                                                        </th>
                                                        <td scope="row" v-text='(stats.user_assignment && typeof stats.user_assignment[user.id] !== "undefined" && typeof stats.user_assignment[user.id][site.id] !== "undefined"? stats.user_assignment[user.id][site.id] : 0)' class="currently-bg1"></td>
                                                        <td scope="row" v-text='(stats.user_waiting && typeof stats.user_waiting[user.id] !== "undefined" && typeof stats.user_waiting[user.id][site.id] !== "undefined" ? parseInt(stats.user_waiting[user.id][site.id]) : 0)' class="currently-bg2"></td>
                                                        <!-- <td scope="row" v-text='(stats.user_assignment && typeof stats.user_assignment[user.id] !== "undefined" ? parseInt(stats.user_assignment[user.id][site.id]) : 0) + (stats.user_completed && typeof stats.user_completed[user.id] !== "undefined" ? parseInt(stats.user_completed[user.id]) : 0)'></th> -->
                                                        <td scope="row" v-text='(stats.user_assignment_today && typeof stats.user_assignment_today[user.id] !== "undefined" && typeof stats.user_assignment_today[user.id][site.id] !== "undefined" ? parseInt(stats.user_assignment_today[user.id][site.id]) : 0)' class="daily-bg1"></td>
                                                        <td scope="row" v-text='(stats.user_completed && typeof stats.user_completed[user.id] !== "undefined" && typeof stats.user_completed[user.id][site.id] !== "undefined" ? stats.user_completed[user.id][site.id] : 0)' class="daily-bg2"></td>
                                                        <!-- <td v-for='date in calendar_dates' scope="col"><span v-for='time in getAvailability(user, date)'>{{time}}</span></td> -->
                                                        <!-- <template  v-if='site_id == "" || user.site_id == site_id' > -->
                                                            <td :key='date.valueOf()' v-for='date in calendar_dates' scope="col">
                                                                <span>{{isAvailable(user, date) ? getCapacity(user, date, site.id) : ""}}</span>
                                                                <!-- <input v-else type="number" min="0" class="text-center" v-model='user.availability[user.id][date.isoWeekday()].capacity'> -->
                                                            </td>
                                                        <!-- </template>
                                                        <template v-else>
                                                            <td :colspan='calendar_dates.length'>&nbsp;</td>
                                                        </template> -->
                                                        <!-- <td class="table-cell-active">12pm - 7pm</td> -->
                                                        <td :key='user.id'>
                                                            <!-- <router-link v-if="is_superuser() || is_admin()" :to="{name: 'staffEdit', params: {id: user.id + '#rota'}}" style="display:block;"><img src="/img/icon-pencil.svg" width="20"></router-link> -->
                                                            <router-link v-if="is_superuser() || is_admin()" :to="'/staff-list/staff-edit/' + user.id + '#rota'" style="display:block;"><img src="/img/icon-pencil.svg" width="20" :title="$t('translations.edit')"></router-link>
                                                            <router-link v-else :to="'/staff-list/staff-show/' + user.id + '#rota'" style="display:block;"><img src="/img/icon-eye.svg" width="20" title="view"></router-link>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </template>
                                        <tr v-else :key='site.id + "-0"'>
                                            <td colspan='9'>{{ $t('translations.filter_no_users_found')}}</td>
                                        </tr>
                                    </template>

                                    <tr v-if='assignable_groups.length'><td colspan='11' class="bg-primary text-light">{{ $t('translations.groups')}}</td></tr>

                                    <template v-for='group in assignable_groups'>
                                        <tr :key='"group" + group.id'>
                                            <th scope="row">
                                                <template v-if='is_network_admin()'>{{group.name}}</template>
                                                <!-- <router-link v-else active-class='' :to='{name: "threadList", params: {assigned_to: "g:" + group.id, secondary_status: []}}'>{{group.name}}</router-link> -->
                                                <router-link v-else active-class='' :to='{name: "threadList", params: {assigned_group_filter: group, site_id: site_id == COMBINED_SITES ? "" : site_id /* NOTE THIS IS site_id the GLOBAL one */}}'>{{group.name}}</router-link>
                                            </th>
                                            <td scope="row" v-text='(stats.group_assignment && typeof stats.group_assignment[group.id] !== "undefined" ? stats.group_assignment[group.id] : 0)' class="currently-bg1"></td>
                                            <td scope="row" v-text='(stats.group_waiting && typeof stats.group_waiting[group.id] !== "undefined" ? parseInt(stats.group_waiting[group.id]) : 0)' class="currently-bg2"></td>
                                            <td scope="row" v-text='(stats.group_assignment_today && typeof stats.group_assignment_today[group.id] !== "undefined" ? parseInt(stats.group_assignment_today[group.id]) : 0)' class="daily-bg1"></td>
                                            <td scope="row" v-text='(stats.group_completed && typeof stats.group_completed[group.id] !== "undefined" ? stats.group_completed[group.id] : 0)' class="daily-bg2"></td>
                                            <td :key='index' v-for='(date, index) in calendar_dates' class="">
                                                <span v-if='show'>{{getGroupCapacity(group, date)}}</span>
                                                <input v-else type="number" min="0" class="text-center" v-model="usergroupcapacity[group.id][date.isoWeekday()].capacity">
                                            </td>
                                            <td v-if='is_superuser() || is_admin()'><img src="/img/icon-pencil.svg" width="20" :title="$t('translations.edit')" v-on:click.prevent="editDashboard()" v-if="show"></td>
                                        </tr>
                                    </template>

                                    <template v-if="$root.provider.provider_provider_xref.length">
                                        <!-- <tr><td colspan='11' style="height: 2em"></td></tr> -->
                                        <tr><td colspan='11' class="bg-primary text-light">{{ $t('translations.providers')}}</td></tr>
                                        <tr>
                                            <th scope="col" colspan="1" class="text-left">
                                                <!-- {{ $t('translations.clinician')}} -->
                                            </th>
                                            <th class='text-center currently-bg1' scope="col"><span>{{ $t('translations.transferred')}}</span></th>
                                            <th class='text-center currently-bg2' scope="col"><span>{{ $t('translations.shared') | capitalise }}</span></th>
                                            <th class='text-center daily-bg1' scope="col"><span>{{ $t('translations.transferred')}}</span></th>
                                            <th class='text-center daily-bg2' scope="col"><span>{{ $t('translations.shared') | capitalise }}</span></th>
                                            <th :key='index' v-for='(date, index) in calendar_dates' class="">
                                                    
                                            </th>
                                            <th scope="col" colspan="1"></th>
                                        </tr>
                                        <template v-for='provider_xref in sortByValue($root.provider.provider_provider_xref, "name", "relation")'>
                                            <tr :key='"provider_xref" + provider_xref.relation.id'>
                                                <th scope="row">
                                                    {{provider_xref.relation.name}}
                                                </th>
                                                <td scope="row" v-text='(stats.transferred_provider_assignment && typeof stats.transferred_provider_assignment[provider_xref.relation.id] !== "undefined" ? stats.transferred_provider_assignment[provider_xref.relation.id] : 0)' class="currently-bg1"></td>
                                                <td scope="row" v-text='(stats.shared_provider_assignment && typeof stats.shared_provider_assignment[provider_xref.relation.id] !== "undefined" ? stats.shared_provider_assignment[provider_xref.relation.id] : 0)' class="currently-bg2"></td>
                                                <td scope="row" v-text='(stats.transferred_provider_assignment_today && typeof stats.transferred_provider_assignment_today[provider_xref.relation.id] !== "undefined" ? stats.transferred_provider_assignment_today[provider_xref.relation.id] : 0)' class="daily-bg1"></td>
                                                <td scope="row" v-text='(stats.shared_provider_assignment_today && typeof stats.shared_provider_assignment_today[provider_xref.relation.id] !== "undefined" ? stats.shared_provider_assignment_today[provider_xref.relation.id] : 0)' class="daily-bg2"></td>
                                                <td :key='index' v-for='(date, index) in calendar_dates' class="">
                                                    
                                                </td>
                                                <td></td>
                                            </tr>
                                        </template>
                                    </template>
                                </tbody>
                            </table>
                        </div>

                    </div>
                    <hr>
                </div>
            </div><!-- flex-grow-1-scroll h-100 -->
            <footer class="container-footer">
            <!-- <footer class="container-footer d-flex flex-row  justify-content-between  align-items-center"> -->

                <!-- <div data-nickelled-launcher="auto-launch" data-guide="https://askmygp.nickelled.com/dashboard"></div> -->
                <!-- <div data-nickelled-launcher="pulse" data-guide="https://askmygp.nickelled.com/dashboard"></div> -->

                <div v-if='is_superuser() || is_admin()' class="d-flex flex-row-reverse">
                    <!-- <button v-on:click.prevent="editDashboard()" v-if="show" class="btn btn-primary btn-round btn-sm mr-2">{{ $t('translations.edit_demand_capacity')}}</button> -->
                    <div v-if="!show" class="">
                        <button v-on:click.prevent="updateDashboard()" class="btn btn-success btn-sm btn-round">{{ $t('translations.save')}}</button>
                        <button v-on:click="cancelUpdateDashboard()" class="btn btn-danger btn-sm btn-round">{{ $t('translations.cancel')}}</button>
                    </div>
                </div>
            </footer>
        </div>

    </div><!--ref:container-->


</template>

<script>
export default {
    props: [
        'id'
    ],
    data: function(){
        return {
            stats: {assigned: 0, unassigned: 0, closed: 0, waiting: 0, time_taken: {}, user_analytics: {}, created_today: 0},
            calendar_dates: [],
            capacity: {},
            demand: {},
            usergroupcapacity: {},
            site_id: "",
            users: this.$root.lookup.staff,
            sites: this.$root.provider.site,
            provider: this.$root.provider,
            user_groups: this.$root.lookup.user_groups,


            show: true,
            errors: [],
            times: {
                online: 2.0,
                phone: 5.0,
                face_to_face: 11.0,
                other_clinician: 15,
                admin: 3,
                time_taken_per_request: 0.5,
            },
            channel: "",
            COMBINED_SITES: -1,
            SHARED_TRANSFERRED_SITES: -2,
            USER_CAPACITY_EDIT_ENABLED: false,
        };
    },
    watch: {

        site_id(new_site_id, old_site_id) {
            console.log("Site ID change: " + old_site_id + " > " + new_site_id);

            this.setSetting("site_id", new_site_id);

            //var old_channel = this.channel;
            //window.setTimeout(() => {console.log("1. Leaving: " + old_channel); console.log("HERE"); window.Echo.leave(old_channel)}, 2000);

            this.changeChannel(this.getChannelName(this.provider_id, new_site_id));

            this.getData(true);
        },
        provider_id(new_provider_id, old_provider_id) {
            console.log("Provider ID change: " + old_provider_id + " > " + new_provider_id);
            this.changeProvider(new_provider_id);
        }
    },
    computed: {
        provider_id: {
            get: function() {
                if(this.is_network_admin()) {
                    return this.$root.admin_provider_id;
                }
                else {
                    return this.$root.provider.id;
                }
            }
        },
        filtered_users() {
            return this.getFilteredUsers(false);
        },
        filtered_users_with_other_site_assign() {
            return this.getFilteredUsers(true);
        },
        assignable_groups() {
            return this.user_groups.filter((obj) => {
                return obj.group_assignable
                    // && (
                    //     (this.stats.group_assignment && this.stats.group_assignment[obj.id])
                    //     || (this.stats.group_assignment_today && this.stats.group_assignment_today[obj.id])
                    //     || (this.stats.group_completed && this.stats.group_completed[obj.id])
                    //     || (this.stats.group_waiting && this.stats.group_waiting[obj.id])
                    // )
            });
        },
        filteredSites() {
            var sites;

            if(this.site_id == this.COMBINED_SITES) {
                sites = [{id: -1, name: this.$t('translations.combined_sites')}];
            }
            else if(this.site_id) {
                sites = this.sites.filter(site => {return site.id == this.site_id});
            }

            else {
                sites = this.sites;

                if(this.filtered_users_with_other_site_assign.filter(user => {return this.userHasAssignmentsFrom(user, 0)}).length) {
                    var sites = sites.concat([{id: 0, name: this.$t('translations.no_site_specified')}]);
                }

                if(this.filtered_users_with_other_site_assign.filter(user => {return this.userHasAssignmentsFrom(user, -2)}).length) {
                    var sites = sites.concat([{id: -2, name: this.$t('translations.shared_transferred') }]);
                }
            }
            
            return sites;
            //return Array.concat(this.sites, [{site_id: "", name: "No Preferred Site Specified"}]);
        }
    },
    created() {
        //console.log("CREATED");
    },
    mounted() {
        //console.log("MOUNTED");
        this.initData();
        if(this.is_network_admin()) {
            this.changeProvider(this.provider_id);
        }
        else {
            this.changeChannel(this.getChannelName(this.provider_id, this.site_id));
            this.getData();
        }


        if (!this.$root.provider.demo_mode) {
            var thisSiteId = this.getSetting("site_id");
            if(thisSiteId == this.COMBINED_SITES || this.sites.find(obj => {return obj.id == thisSiteId})) {
                this.site_id = thisSiteId;
            }
            else {
                this.setSetting("site_id", "");
            }

        }
        //this.showNickelled();
    },
    beforeDestroy() {
        this.deinitData();
    },
    beforeRouteLeave (to, from, next) {
        this.deinitData();
        next();
    },
    methods: {
        changeChannel(new_channel) {
            console.log("1. Leaving: " + this.channel);
            window.Echo.leave(this.channel);
            this.channel = new_channel;
            console.log("1. Joining: " + this.channel);
            window.Echo.private(this.channel)
                .listen('UpdateCompletedStatistics', (e) => {
                    //this.addNotification({type: "success", content: 'New completed statistics'});
                    this.processPushedStats(e)

                });
            this.listenWithChunking(this.channel, 'UpdateStatistics', (e) => {
                //this.addNotification({type: "success", content: 'New statistics'});
                this.processPushedStats(e)

            });
        },
        getFilteredUsers(with_other_site_assign) {
            var filteredUsers = this.users.filter(staff => {
                return this.isMemberOfAssignableGroup(staff)
				|| (this.stats 
						&& (
							(this.stats.user_assignment && this.stats.user_assignment[staff.id])
							|| (this.stats.user_assignment_today && this.stats.user_assignment_today[staff.id])
							|| (this.stats.user_completed && this.stats.user_completed[staff.id])
							|| (this.stats.user_waiting && this.stats.user_waiting[staff.id])
						)	
					);
                // && (
                //     this.site_id == ""
                //     || staff.site_id == this.site_id
                //     || ( with_other_site_assign == true &&
                //         this.stats && this.stats.user_assignment && this.stats.user_assignment[staff.id][site_id]
                //     ));
            });

            filteredUsers.sort((staff1, staff2) => {
                // var site1 = this.sites.find(site => {return staff1.site_id == site.id});
                // var site2 = this.sites.find(site => {return staff2.site_id == site.id});
                // if(typeof site1 != "undefined" && typeof site2 != "undefined") {
                //     if(site1.name == site2.name) {
                        return this.formatSurname(staff1).localeCompare(this.formatSurname(staff2));
                //     }
                //     return site1.name.localeCompare(site2.name);
                // }
                // if(typeof site1 == "undefined" && typeof site2 == "undefined") {
                //     return this.formatSurname(staff1).localeCompare(this.formatSurname(staff2));
                // }
                // if(typeof site1 == "undefined") {
                //     return 1;
                // }
                // if(typeof site2 == "undefined") {
                //     return -1;
                // }
            });
            return filteredUsers;
        },
        getChannelName(provider_id, site_id) {
            console.log("Channel name: " + 'stats' + (this.provider.demo_mode ? '-completed' : '') + '.' + provider_id + (site_id > 0 ? `.${site_id}` : ""));
            return 'stats' + (this.provider.demo_mode ? '-completed' : '') + '.' + provider_id + (site_id > 0 ? `.${site_id}` : "");
        },
        loadProvider() {
            return axios.get(this.$root.apiBase + '/providers/' + this.provider_id);
        },
        loadLookup(endpoint) {
            return axios.get(this.$root.apiBase + '/' + endpoint + '?provider_id=' + this.provider_id + '&p=0');
        },
        changeProvider(provider_id) {

            if(provider_id) {
                this.setLoading(true);
                this.site_id = "";
                axios.all([this.loadProvider(), this.loadLookup("usergroups"), this.loadLookup("staff")])
                .then(axios.spread((provider, userGroups, staff) => {
                    this.provider = provider.data.provider;
                    this.sites = this.provider.site;
                    this.user_groups = userGroups.data.data;
                    this.users = staff.data.data;
                    for(var index in this.users) {
                        this.$root.setAvailability(this.users[index], 0, 0);
                    }

                    this.changeChannel(this.getChannelName(provider_id, this.site_id));
                    this.setLoading(false);
                    this.getData(true);
                }))
                .catch(error => {
                    console.log("Dashboard failed to load: " + JSON.stringify(error, null, 2));
                });
            }
        },
        initData() {
            for(var dayLoop = 0; dayLoop < 7 && this.calendar_dates.length < 5; dayLoop++) {
                var date = this.moment().add(dayLoop, 'days');
                var weekday = date.isoWeekday();
                if(weekday < 6) {
                    this.calendar_dates.push(this.moment().add(dayLoop, 'days'));
                }
            }

        },
        deinitData() {
            window.Echo.leave(this.channel);
        },
        matchingStats(stats) {
            // Not very elegant, but null in a select list doesn't work, so we have
            // to compare the empty value, and also COMBINED_SITES (-1) requires a null (full) site listing.
            return (stats.provider_id == this.provider_id
                && stats.site_id == ((this.site_id == "" || this.site_id == this.COMBINED_SITES) ? null : this.site_id));
        },
        processStats() {
            this.$set(this.stats, "time_taken", {});
            //this.stats.time_taken = {};
            for(var index in this.users) {
                //this.stats.time_taken[index] = 60;
                if(this.stats.user_completed[this.users[index].id]) {
                    this.$set(this.stats.time_taken, this.users[index].id, this.stats.user_completed[this.users[index].id] * this.times.time_taken_per_request)
                }
                else {
                    this.$set(this.stats.time_taken, this.users[index].id, 0);
                }
            };

            for(var index in this.users) {
                //this.stats.time_taken[index] = 60;
                if(this.stats.user_completed[this.users[index].id]) {
                    delete(this.stats.user_completed[this.users[index].id][-1]);
                    this.stats.user_completed[this.users[index].id][-1] 
                        = Object.values(this.stats.user_completed[this.users[index].id]).reduce((a, b) => a + b, 0);
                    delete(this.stats.user_completed[this.users[index].id][-2]);
                    this.stats.user_completed[this.users[index].id][-2] 
                        = this.statsForNonLocalSites(this.stats.user_completed, this.users[index].id);
                }
                if(this.stats.user_assignment[this.users[index].id]) {
                    delete(this.stats.user_assignment[this.users[index].id][-1]);
                    this.stats.user_assignment[this.users[index].id][-1] 
                        = Object.values(this.stats.user_assignment[this.users[index].id]).reduce((a, b) => a + b, 0);
                    delete(this.stats.user_assignment[this.users[index].id][-2]);
                    this.stats.user_assignment[this.users[index].id][-2] 
                        = this.statsForNonLocalSites(this.stats.user_assignment, this.users[index].id);
                        
                }
                if(this.stats.user_assignment_today && this.stats.user_assignment_today[this.users[index].id]) {
                    delete(this.stats.user_assignment_today[this.users[index].id][-1]);
                    this.stats.user_assignment_today[this.users[index].id][-1] 
                        = Object.values(this.stats.user_assignment_today[this.users[index].id]).reduce((a, b) => a + b, 0);
                    delete(this.stats.user_assignment_today[this.users[index].id][-2]);
                    this.stats.user_assignment_today[this.users[index].id][-2] 
                        = this.statsForNonLocalSites(this.stats.user_assignment_today, this.users[index].id);
                }
                if(this.stats.user_waiting && this.stats.user_waiting[this.users[index].id]) {
                    delete(this.stats.user_waiting[this.users[index].id][-1]);
                    this.stats.user_waiting[this.users[index].id][-1] 
                        = Object.values(this.stats.user_waiting[this.users[index].id]).reduce((a, b) => a + b, 0);
                    delete(this.stats.user_waiting[this.users[index].id][-2]);
                    this.stats.user_waiting[this.users[index].id][-2] 
                        = this.statsForNonLocalSites(this.stats.user_waiting, this.users[index].id);
                }

            };
        },
        statsForNonLocalSites(stats, user_id) {
            return Object.values(
                Object.keys(
                    stats[user_id]
                )
                .filter(
                    site_id => {
                        return site_id <= 0 ? false : this.sites.find(site => {return site.id == site_id}) ? false : true
                    }
                )
                .reduce((obj, key) => {
                    obj[key] = stats[user_id][key];
                    return obj;
                }, {})
            )
            .reduce((a, b) => a + b, 0);
        },
        processPushedStats(e) {
            if(e && e.stats) {
                console.log("Using stats from channel: " + this.channel);
                //console.log(e);
                // horrible comparison, but the select lists don't work with null, and I don't want to pass a zero length string
                // back from the web service.
                if(this.matchingStats(e.stats)) {
                    console.log("Processing pushed data: " + e.stats.provider_id + " - " + e.stats.site_id);
                    this.stats = e.stats;
                    this.processStats();
                }
                else {
                    console.log("Ignoring out-of-order stats data: " + e.stats.provider_id + " - " + e.stats.site_id);
                }
            }
            else {
                console.log("Pulling stats from server. Slow.")
                this.getData();
            }
        },
        getData(showLoading) {
            if(showLoading === true) {
                this.setLoading(true);
            }
            var endpoint = "getStats";
            if(this.provider.demo_mode) {
                endpoint = "getCompletedStats";
            }
            axios.get(this.$root.apiBase + '/threads/' + endpoint, {params: {provider_id: this.provider_id, site_id: (this.site_id == -1 ? "" : this.site_id)}}).then((res) => {
                this.setLoading(false);
                if(this.matchingStats(res.data)) {
                    console.log("Processing pulled data: " + res.data.provider_id + " - " + res.data.site_id);
                    this.stats = res.data;
                    this.processStats();
                }
                else {
                    console.log("Ignoring out-of-order stats data: " + res.data.provider_id + " - " + res.data.site_id);
                }
            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "create");
            });
        },
        updateTimeTaken() {
            for(var index in this.stats.time_taken) {
                //this.stats.time_taken[index] = 60;
                if(this.stats.user_completed[index]) {
                    this.stats.time_taken[index] = this.stats.user_completed[index] * this.times.time_taken_per_request;
                }
                else {
                    this.stats.time_taken[index] = 0;
                }
            };
        },
        getDemand(date) {
            var dayOfWeek = date.isoWeekday();
            var demand = 0;
            if(this.provider.demand) {
                var demand_data = this.provider.demand.find(obj => {return obj.day_of_week == dayOfWeek});
                if(demand_data) {
                    demand = demand_data.demand;
                }
            }
            return demand ? demand : "";
        },
        getGroupCapacity(group, date) {
            var dayOfWeek = date.isoWeekday();
            //console.log("DOW: " + dayOfWeek)
            var capacity = 0;
            if(Array.isArray(group.usergroupcapacity)) {
                var capacity_data = group.usergroupcapacity.find(obj => {return obj.day_of_week == dayOfWeek});
                if(capacity_data) {
                    capacity = capacity_data.capacity;
                }
            }
            return capacity ? capacity : "";
        },
        _DEPRECATED_getCapacity(user, date) {
            var dayOfWeek = date.isoWeekday();
            var capacity = 0;
            if(user.capacity) {
                var capacity_data = user.capacity.find(obj => {return obj.day_of_week == dayOfWeek});
                if(capacity_data) {
                    capacity = capacity_data.capacity;
                }
            }
            return capacity ? capacity : "";
        },
        getCapacity(user, date, site_id) {
            var weekDay = date.isoWeekday();
            var day = date.format("YYYY-MM-DD");
            var capacity = 0;

            //console.info(JSON.stringify(date, null, 2));

            if(Array.isArray(user.availability_date) && user.availability_date.length) {
                var availability_dates = user.availability_date.filter(obj => {
                    var date_from = null;
                    var date_to = null;

                    if(this.moment(obj.date_from, 'YYYY-MM-DD').isValid()) {
                        date_from = this.moment(obj.date_from, 'YYYY-MM-DD').format("YYYY-MM-DD");
                    }
                    if(this.moment(obj.date_to, 'YYYY-MM-DD').isValid()) {
                        date_to = this.moment(obj.date_to, 'YYYY-MM-DD').format("YYYY-MM-DD");
                    }

                    if(date_from) {
                        if((date_to && date_from <= day && date_to >= day)
                                || (!date_to && date_from == day)) {
                            return obj.availability_time.find(availability_time => {return this.isCurrentProviderSite(availability_time.site_id, this.sites)});
                        }
                        //return date_to ? (date_from <= day && date_to >= day) : (date_from == day);
                    }
                    return false;
                    //return obj.date_to ? (obj.date_from <= day && obj.date_to >= day) : (obj.date_from == day);
                });
                if(!availability_dates.length) {
                    availability_dates = user.availability_date.filter(obj => {return obj.day_of_week == weekDay});
                }
                //console.info(JSON.stringify(availability_dates, null, 2));
                for(var index in availability_dates) {

                    for(var dIndex in availability_dates[index].availability_time) {
                        //console.info(site_id);
                        //console.info(availability_dates[index].availability_time[dIndex].site_id);
                        if(this.isCurrentProviderSite(availability_dates[index].availability_time[dIndex].site_id, this.sites)) {
                            if(typeof site_id == "undefined" || site_id == this.COMBINED_SITES || availability_dates[index].availability_time[dIndex].site_id == site_id) {
                                capacity += availability_dates[index].availability_time[dIndex].capacity;
                            }
                        }
                    }
                }
            }
            return capacity ? capacity : "";
        },
        getTotalCapacity(date) {
            var totalCapacity = 0;
            var thisCapacity;
            for(var index in this.filtered_users) {
                thisCapacity = 0;
                if(this.USER_CAPACITY_EDIT_ENABLED === false || this.show) {
                    if(this.isAvailable(this.filtered_users[index], date)) {
                        //console.log("Looking at: " + this.formatName(this.filtered_users[index]) + ": " + date.isoWeekday() + ": " + this.getCapacity(this.filtered_users[index], date));

                        thisCapacity = this.getCapacity(this.filtered_users[index], date);
                    }
                }
                else {
                    //console.log("Looking at: " + this.filtered_users[index].id + ": " + date.isoWeekday());
                    thisCapacity = this.capacity[this.filtered_users[index].id][date.isoWeekday()].capacity;
                    //console.log(thisCapacity);
                }
                // Fudge the empty strings from getCapacity. Sigh.
                totalCapacity += parseInt(thisCapacity ? thisCapacity : 0);
                //console.log("totalCapacity: " + totalCapacity);
            }

            for(var index in this.assignable_groups) {
                thisCapacity = 0;
                if(this.show) {
                    thisCapacity = this.getGroupCapacity(this.assignable_groups[index], date);
                }
                else {
                    //console.log("Looking at: " + this.filtered_users[index].id + ": " + date.isoWeekday());
                    if(this.usergroupcapacity[this.assignable_groups[index].id] && this.usergroupcapacity[this.assignable_groups[index].id][date.isoWeekday()]) {
                        thisCapacity = this.usergroupcapacity[this.assignable_groups[index].id][date.isoWeekday()].capacity;
                    }
                    //console.log(thisCapacity);
                }
                // Fudge the empty strings from getCapacity. Sigh.
                totalCapacity += parseInt(thisCapacity ? thisCapacity : 0);
                //console.log("totalCapacity: " + totalCapacity);
            }

            return totalCapacity ? totalCapacity : "";
        },
        isAvailable(user, date) {
            var day = date.format("YYYY-MM-DD");
            var weekDay = date.isoWeekday();

            var times = [];

            if(Array.isArray(user.availability_date) && user.availability_date.length) {
                var availability_dates = user.availability_date.filter(obj => {
                    var date_from = this.moment(obj.date_from, 'YYYY-MM-DD').format("YYYY-MM-DD");
                    var date_to = this.moment(obj.date_to, 'YYYY-MM-DD').format("YYYY-MM-DD");

                    if(date_from) {
                        if((date_to && date_from <= day && date_to >= day)
                                || (!date_to && date_from == day)) {
                            return obj.availability_time.find(availability_time => {return this.isCurrentProviderSite(availability_time.site_id, this.sites)});
                        }
                        //return date_to ? (date_from <= day && date_to >= day) : (date_from == day);
                    }

                    //return date_to ? (date_from <= day && date_to >= day) : (date_from == day);
                    //return obj.date_to ? (obj.date_from <= day && obj.date_to >= day) : (obj.date_from == day);
                });
                if(!availability_dates.length) {
                    availability_dates = user.availability_date.filter(obj => {return obj.day_of_week == weekDay});
                }
                //console.debug(availability_dates.length);
                for(var dIndex in availability_dates) {
                    for(var index in availability_dates[dIndex].availability_time) {
                        if(this.isCurrentProviderSite(availability_dates[dIndex].availability_time[index].site_id, this.sites)) {
                        
                            var time = this.getTimeRange(availability_dates[dIndex].availability_time[index]);
                            if(time && this.sites.find(obj => {return availability_dates[dIndex].availability_time[index].site_id == obj.id})) {
                                times.push(time);
                            }
                        }
                    }
                }
                //console.debug(times.length);
                if(times.length) {
                    return true;
                }
            }
            return false;
        },
        getTotalAnalytics(type) {
            var totalAnalytics = 0;
            for(var index in this.filtered_users) {
                if(this.stats.user_analytics && this.stats.user_analytics[this.filtered_users[index].id] && this.stats.user_analytics[this.filtered_users[index].id][type]) {
                    var thisAnalytics = this.stats.user_analytics[this.filtered_users[index].id][type];
                    // Fudge the empty strings from getCapacity. Sigh.
                    totalAnalytics += thisAnalytics ? thisAnalytics : 0;
                }
            }
            return totalAnalytics ? totalAnalytics : "";
        },
        getTotalTimeTaken() {
            var total = 0;
            for(var index in this.stats.time_taken) {
                if(parseFloat(this.stats.time_taken[index])) {
                    total += parseFloat(this.stats.time_taken[index]);
                }
            };
            return total ? total.toFixed(1) : "";
        },
        getTotalGP() {
            var total = 0;
            var totalPhone = this.getTotalAnalytics("phone");
            if(totalPhone) {
                total += totalPhone;
            }
            var totalF2F = this.getTotalAnalytics("face_to_face");
            if(totalF2F) {
                total += totalF2F;
            }
            var totalOnline = this.getTotalAnalytics("online");
            if(totalOnline) {
                total += totalOnline;
            }



            return total ? total : "";

        },
        getGP(user) {
            var total = 0;
            var totalPhone = (this.stats.user_analytics && typeof this.stats.user_analytics[user.id] !== "undefined" ? this.stats.user_analytics[user.id]["phone"] : 0);
            if(totalPhone) {
                total += totalPhone;
            }
            var totalF2F = (this.stats.user_analytics && typeof this.stats.user_analytics[user.id] !== "undefined" ? this.stats.user_analytics[user.id]["face_to_face"] : 0);
            if(totalF2F) {
                total += totalF2F;
            }
            var totalOnline = (this.stats.user_analytics && typeof this.stats.user_analytics[user.id] !== "undefined" ? this.stats.user_analytics[user.id]["online"] : 0);
            if(totalOnline) {
                total += totalOnline;
            }

            return total ? total.toFixed(1) : "";

        },
        getTotalAnalyticsMinutes(type) {
            var totalAnalytics = this.getTotalAnalytics(type);
            if(totalAnalytics) {
                return (totalAnalytics * this.times[type]).toFixed(1);
            }
            return "";
        },
        getTotalGPMinutes() {
            var total = 0.0;
            var totalPhone = this.getTotalAnalytics("phone");
            if(totalPhone) {
                total += totalPhone * this.times["phone"];
            }
            var totalF2F = this.getTotalAnalytics("face_to_face");
            if(totalF2F) {
                total += totalF2F * this.times["face_to_face"];
            }
            var totalOnline = this.getTotalAnalytics("online");
            if(totalOnline) {
                total += totalOnline * this.times["online"];
            }

            var totalTimeTaken = this.getTotalTimeTaken();
            if(totalTimeTaken && parseFloat(totalTimeTaken)) {
                total += parseFloat(totalTimeTaken);
            }

            return total ? total.toFixed(0) : "";

        },
        getGPMinutes(user) {
            var total = 0;
            var totalPhone = (this.stats.user_analytics && typeof this.stats.user_analytics[user.id] !== "undefined" ? this.stats.user_analytics[user.id]["phone"] : 0);
            if(totalPhone) {
                total += totalPhone * this.times["phone"];
            }
            var totalF2F = (this.stats.user_analytics && typeof this.stats.user_analytics[user.id] !== "undefined" ? this.stats.user_analytics[user.id]["face_to_face"] : 0);
            if(totalF2F) {
                total += totalF2F * this.times["face_to_face"];
            }
            var totalOnline = (this.stats.user_analytics && typeof this.stats.user_analytics[user.id] !== "undefined" ? this.stats.user_analytics[user.id]["online"] : 0);
            if(totalOnline) {
                total += totalOnline * this.times["online"];
            }

            if(this.stats.time_taken[user.id] && parseFloat(this.stats.time_taken[user.id])) {
                total += parseFloat(this.stats.time_taken[user.id]);
            }

            return total ? total.toFixed(0) : "";

        },
        getAverageMinutesPerRequest() {
            var totalMinutes = this.getTotalGPMinutes();
            var totalRequests = this.getTotalGP();
            if(totalMinutes && totalRequests) {
                return (totalMinutes / totalRequests).toFixed(1);
            }
            return "";
        },
        getUserAverageMinutesPerRequest(user) {
            var totalMinutes = this.getGPMinutes(user);
            var totalRequests = this.getGP(user);
            // alert(user.id);
            // alert(totalMinutes);
            // alert(totalRequests);
            if(totalMinutes && totalRequests) {
                return (totalMinutes / totalRequests).toFixed(1);
            }
            return "";
        },
        getTimeSaved() {
            var averageMinutesPerRequest = this.getAverageMinutesPerRequest();
            if(averageMinutesPerRequest) {
                return (this.times["face_to_face"] - averageMinutesPerRequest).toFixed(1);
            }
            return "";
        },
        getTimePercentageSaved() {
            var averageMinutesPerRequest = this.getAverageMinutesPerRequest();
            if(averageMinutesPerRequest) {
                var difference = this.times["face_to_face"] - averageMinutesPerRequest;
                difference /= this.times["face_to_face"];
                difference *= 100;
                return "" + Math.round(difference) + "%";
            }
            return "";
        },
        getUserTimePercentageSaved(user) {
            var averageMinutesPerRequest = this.getUserAverageMinutesPerRequest(user);
            if(averageMinutesPerRequest) {
                var difference = this.times["face_to_face"] - averageMinutesPerRequest;
                difference /= this.times["face_to_face"];
                difference *= 100;
                return "" + Math.round(difference) + "%";
            }
            return "";
        },
        getTimeRange(time) {
            if(time.from) {
                return this.formatShortTime(time.from) + " - " + this.formatShortTime(time.to);
            }
            return false;
        },
        isMemberOfAssignableGroup(user) {
            if(this.provider && this.provider.demo_mode) {
                return true;
            }
            for(var index in this.user_groups) {
                if(this.user_groups[index].members_assignable) {
                    for(var userIndex in this.user_groups[index].usersusergroup) {
                        if(this.user_groups[index].usersusergroup[userIndex].user_id == user.id) {
                            return true;
                        }
                    }
                }
            }
            return false;
        },
        editDashboard() {
            this.show = false;
            this.users.forEach((user, index, array) => {
                if(!this.capacity[user.id]) {
                    //this.capacity[user.id] = {};
                    Vue.set(this.capacity, user.id, {});
                }
                if(Array.isArray(user.capacity) && user.capacity.length) {

                    this.calendar_dates.forEach((date, index2, array2) => {
                        //this.capacity.push({id: user.id, day_of_week: date.isoWeekday()});
                        Vue.set(this.capacity[user.id], date.isoWeekday(), JSON.parse(JSON.stringify(user.capacity.find((obj) => {return obj.day_of_week == date.isoWeekday()}))));
                        //this.capacity[user.id][date.isoWeekday()] = JSON.parse(JSON.stringify(user.capacity.find((obj) => {return obj.day_of_week == date.isoWeekday()})));
                    });
                }
                else {
                    this.calendar_dates.forEach((date, index2, array2) => {
                        Vue.set(this.capacity[user.id], date.isoWeekday(), {user_id: user.id, day_of_week: date.isoWeekday(), capacity: 0});
                    });
                }
            });
            this.calendar_dates.forEach((date) => {
                Vue.set(this.demand, date.isoWeekday(), {day_of_week: date.isoWeekday(), demand: this.getDemand(date)});
            });


            this.assignable_groups.forEach((group) => {
                var group_capacity = {};
                this.calendar_dates.forEach((date) => {
                    var capacity = group.usergroupcapacity.find(obj => obj.day_of_week == date.isoWeekday());
                    if(!capacity) {
                        capacity = {
                            day_of_week: date.isoWeekday(),
                            capacity: 0
                        };
                    }

                    // Copy it
                    // @todo What? Why is this done with a deep copy? Capacity is recreated in each loop
                    // isn't it? Oh hang on. No maybe because it is a var, not a "local". Hmmmm. Needs testing.
                    group_capacity[date.isoWeekday()] = JSON.parse(JSON.stringify(capacity));
                });

                Vue.set(this.usergroupcapacity, group.id, group_capacity);
            });
        },
        updateDashboard() {
            this.errors = [];
            this.setLoading(true);
			axios
				.put("/api/v1/providers/updateDemandCapacity/" + this.$root.user.provider.id, {demand: this.demand, capacity: this.capacity, usergroupcapacity: this.usergroupcapacity})
				.then(res => {
                    this.$root.loadCore().then(() => {
                        this.setLoading(false);
                        this.addNotification({
                            type: "success",
                            content: this.$t('translations.demand_capacity_updated_success')
                        });
                        this.show = true;
                    });

				})
			.catch(error => {
                this.setLoading(false);
				this.handleError(error, "update");
			});

        },
        cancelUpdateDashboard() {
            this.errors = [];
            this.show = true;
            this.getData(true);
        },

        _DEPRECATED_getUserSite(user) {

            if(Array.isArray(this.sites)) {
                var site = this.sites.find(site => {return user.site_id == site.id});
                if(site) {
                    return site.name;
                }
            }
            return "";
        },

        userHasAssignmentsFrom(user, site_id) {
            if(this.stats
                    && (this.stats.user_assignment && this.stats.user_assignment[user.id] && this.stats.user_assignment[user.id][site_id])
                    || (this.stats.user_assignment_today && this.stats.user_assignment_today[user.id] && this.stats.user_assignment_today[user.id][site_id])
                    || (this.stats.user_waiting && this.stats.user_waiting[user.id] && this.stats.user_waiting[user.id][site_id])
                    || (this.stats.user_completed && this.stats.user_completed[user.id] && this.stats.user_completed[user.id][site_id])) {
                return true;
            }

            return false;
        },
        getFilteredSites() {
            if(this.site_id) {
                return this.sites.filter(site => {return obj.site.id == this.site_id});
            }
            return this.sites;
            //return Array.concat(this.sites, [{site_id: "", name: "No Preferred Site Specified"}]);
        },
        /**
         * Simple helper function to get the total value of one of the sites, where we aren't interested
         * in filtering by site.
         */
        getTotalStat(item) {
            var total = 0;

            for(var index in item) {
                total += item[index];
            }

            return total;
        }

    }
}
</script>
